import axios from 'axios';
import { clearAuthCookiesDocument, clearBrowserSession, markSessionExpiredNotice } from '../authSession';

// Set REACT_APP_API_BASE_URL at BUILD time (Create React App inlines it), e.g.
// REACT_APP_API_BASE_URL=https://ksa.litvik.in/api
// Falls back to the local dev server so `npm start` keeps working unchanged.
const DEFAULT_API_BASE_URL = 'http://localhost:8000/api';

export function getApiBaseUrl() {
    const configured = (process.env.REACT_APP_API_BASE_URL || '').trim();
    return (configured || DEFAULT_API_BASE_URL).replace(/\/+$/, '');
}

export function clearAuthSession() {
    clearAuthCookiesDocument();
    clearBrowserSession();
}

export function handleUnauthorized() {
    markSessionExpiredNotice();
    clearAuthSession();
    const path = window.location.pathname || '/';
    if (path !== '/') {
        window.location.href = '/';
    }
}

export function getApiClient(cookies, options = {}) {

    const axiosClient = axios.create({
        timeout: options.timeout ?? 180000,
        headers: {
            'Authorization': `Token ${cookies['myToken']}`,
            'Content-Type': "application/json",
        }
    });

    axiosClient.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                handleUnauthorized();
            }
            return Promise.reject(error);
        }
    );

    return axiosClient;
}